
const mapStatetoProps = store => {
  return {
    prepare: store.prepare
  }
}

export default mapStatetoProps;